namespace $.$$ {
	export class $shm_hitalama_attach extends $.$shm_hitalama_attach {
		
		@ $mol_action
		attach_new( files: File[] ) {
			this.files( files )
		}
		
	}
}
